import {
  Stack,
  type StackProps,
  Text,
  VStack,
} from '@adc/parallax-component-library';

import { _config } from '~/utilities/envConfig';

export const MainContainer = (props: StackProps) => (
  <VStack
    backgroundColor="$surface.background"
    justifyContent="space-between"
    style={[{ minHeight: '-webkit-fill-available', height: '100dvh' }]}
    {...props}
  >
    {props.children}
    {_config.mode !== 'production' && (
      <Stack
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
          opacity: 0.5,
        }}
      >
        <Text type="$labelXSmall.default" textAlign="center">
          {`Version: ${__APP_VERSION__}`}
        </Text>
        <Text type="$labelXSmall.default" textAlign="center">
          {_config.mode}
        </Text>
      </Stack>
    )}
  </VStack>
);
